import api from './client.js'

export const gamesAPI = {
  list:   (params) => api.get('/games', { params }),
  get:    (slug)   => api.get(`/games/${slug}`),
  downloadStatus: (slug) => api.get(`/games/${slug}/download-status`),
  precache:       (slug) => api.post(`/games/${slug}/precache`),

  // Admin
  adminList:       () => api.get('/admin/games'),
  adminUpdate:     (id, patch) => api.put(`/admin/games/${id}`, patch),
  adminDelete:     (id) => api.delete(`/admin/games/${id}`),
  adminFetchIgdb:      (id, igdbId = null) =>
    api.post(`/admin/games/${id}/fetch-igdb`, igdbId ? { igdb_id: igdbId } : {}),
  adminIgdbSearch:     (q) => api.get('/admin/games/igdb-search', { params: { q } }),
  adminIgdbMedia:      (igdbId) => api.get('/admin/games/igdb-media', { params: { igdb_id: igdbId } }),
  // Timeout ruim — yt-dlp trailer-download loopt tot 3 min (retries over 3
  // player-clients + merge). Default axios is 10s, wat een timeout gaf.
  adminApplyMedia:     (id, payload) =>
    api.post(`/admin/games/${id}/apply-media`, payload, { timeout: 240_000 }),
  adminScan:       () => api.post('/admin/games/scan'),
  adminRefetchAll: () => api.post('/admin/games/refetch-all'),
  adminExtractEti: (id, force = false) =>
    api.post(`/admin/games/${id}/extract-eti${force ? '?force=1' : ''}`, {}),
  adminExtractStatus: (id) => api.get(`/admin/games/${id}/extract-status`),
  adminExtractJobs:   () => api.get('/admin/games/extract-jobs'),
  adminGetConfig:  () => api.get('/admin/games/config/all'),
  adminSetConfig:  (config) => api.put('/admin/games/config/all', config),
}
